package com.tixforgigs.common.ui.components.buttons


import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.tarami.AraiMessage.messageTicketsReserved
import io.kvision.core.Container
import io.kvision.core.Placement
import io.kvision.core.TooltipOptions
import io.kvision.core.enableTooltip
import io.kvision.event.clickFlow
import io.kvision.html.div
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.icon.icon
import io.kvision.material.iconbutton.iconButton
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.launchIn
import kotlinx.coroutines.flow.onEach


@OptIn(ExperimentalMaterialApi::class)
@Deprecated("use Container.headerIcon instead", ReplaceWith("headerIcon"))
class HeaderIcon(
  var icon: String,
  var label: String,
  private val onClick: () -> Unit,
  private val badge: StateFlow<Int?>? = null,
): SimplePanel() {

  init {
    simplePanel(className = "xm-action-button") {
      iconButton(className = "xm-icon-button") {
        icon(icon)
        setAttribute("aria-label", label)
      }.clickFlow.onEach {
        onClick()
      }.launchIn(MainScope())
      badge?.let { badge ->
        div(className = "xm-badge").bind(badge) { badgeCount ->
          enableTooltip(
            TooltipOptions(
              title = messageTicketsReserved(badgeCount.orElse { 0 }),
              delay = 140,
              hideDelay = 220,
              placement = Placement.AUTO
            )
          )
          badgeCount?.let { +"$it" }
        }
      }
    }
  }
}

@OptIn(ExperimentalMaterialApi::class)
fun Container.headerIcon(
  icon: String,
  label: String,
  onClick: () -> Unit,
  badge: StateFlow<Int?>? = null,
) {
  simplePanel(className = "xm-action-button") {
    iconButton(className = "xm-icon-button") {
      icon(icon)
      setAttribute("aria-label", label)
    }.clickFlow.onEach {
      onClick()
    }.launchIn(MainScope())
    badge?.let { badge ->
      div(className = "xm-badge").bind(badge) { badgeCount ->
        enableTooltip(
          TooltipOptions(
            title = messageTicketsReserved(badgeCount.orElse { 0 }),
            delay = 140,
            hideDelay = 220,
            placement = Placement.AUTO
          )
        )
        badgeCount?.let { +"$it" }
      }
    }
  }
}
